import { cn } from '@/lib/utils'
import { TrendLabel } from '.'
import { Skeleton } from '@/components/ui/skeleton'
import { getTrendTypeClass } from '@/utils/helpers'

interface WrapperCardProps {
  icon?: React.ReactNode | string
  title?: string
  total?: string
  trend?: string
  trendType?: 'positive' | 'negative' | string
  headerClassName?: string
  trendClass?: string
  trendCountClass?: string
  titleClassName?: string
  iconClassName?: string
  isTrend?: boolean
  children?: React.ReactNode
  wrapperClassName?: string
  loading?: boolean
  onClick?: () => void
  trendText?: string
  trendCountText?: string
}

export default function WrapperCard({
  icon,
  title,
  total,
  trend,
  trendType,
  headerClassName,
  trendClass,
  trendCountClass,
  titleClassName,
  iconClassName,
  isTrend = false,
  children,
  wrapperClassName,
  loading = false,
  onClick,
}: WrapperCardProps) {
  // Use trendType to determine trendClass if trendClass is not explicitly provided
  const resolvedTrendClass =
    trendClass || (trendType ? getTrendTypeClass(trendType) : undefined)

  return (
    <div
      className={cn(
        'bg-white rounded-[1.15rem] p-5 flex flex-col justify-between',
        wrapperClassName
      )}
      onClick={onClick}
    >
      <div className={cn('flex justify-between', headerClassName)}>
        {loading ? (
          <Skeleton className='h-6 w-32' />
        ) : (
          title && (
            <span
              className={cn(
                'text-[1.1rem] SFPro-Semibold font-bold tracking-wider',
                titleClassName
              )}
            >
              {title}
            </span>
          )
        )}
        {loading ? (
          <Skeleton className='h-10 w-10 rounded-full' />
        ) : (
          icon && (
            <span className={cn('bg-gray-50 p-2 rounded-full', iconClassName)}>
              <figure>{icon}</figure>
            </span>
          )
        )}
      </div>
      {loading ? (
        <div className='space-y-2'>
          <Skeleton className='h-8 w-16' />
          <Skeleton className='h-4 w-28' />
        </div>
      ) : isTrend ? (
        <TrendLabel
          trendCountClass={trendCountClass}
          trendClass={resolvedTrendClass}
          total={total}
          trend={trend}
        />
      ) : (
        children
      )}
    </div>
  )
}
